export default "__VITE_ASSET__1131fa24__"